module.exports = __webpack_public_path__ + "img/removecandidate.48036778.svg";